import {
    bbox,
    bearing,
    bezierSpline,
    destination,
    lineString,
    lineToPolygon,
    multiPoint,
    point,
    transformTranslate,
} from '@turf/turf';

export function createFovPolygon(
    startLat: number,
    startLng: number,
    bearing: number,
    distanceFromLocation = 0.01
) {
    const p1 = point([startLng, startLat]);
    const p2 = destination(p1, distanceFromLocation, bearing);
    const p2Extended = destination(p1, distanceFromLocation * 1.15, bearing);

    const p3 = transformTranslate(p2, distanceFromLocation / 2, bearing + 90);
    const p4 = transformTranslate(p2, distanceFromLocation / 2, bearing + 270);

    const l3 = lineString([
        p3.geometry.coordinates,
        p2Extended.geometry.coordinates,
        p4.geometry.coordinates,
    ]);
    const curved = bezierSpline(l3);

    const newLineString = lineString([
        p1.geometry.coordinates,
        ...curved.geometry.coordinates,
        p1.geometry.coordinates,
    ]);
    return lineToPolygon(newLineString);
}

export function getBearingForPanorama(
    startLat: number,
    startLng: number,
    endLat: number,
    endLng: number
): number {
    const startPoint = point([startLng, startLat]);
    const endPoint = point([endLng, endLat]);
    return bearing(startPoint, endPoint);
}

export function getGoogleLatLngBoundsFromFeatures(points: Array<any>) {
    // minX, minY, maxX, maxY
    const turfMultipoint = multiPoint(
        points.map((p) => p.geometry.coordinates)
    );
    const turfBbox = bbox(turfMultipoint);

    // return sw lat lng, ne lat lng
    const sw = { lng: turfBbox[0], lat: turfBbox[1] };
    const ne = { lng: turfBbox[2], lat: turfBbox[3] };

    return new google.maps.LatLngBounds(sw, ne);
}
